import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/UseAuth";
import { useSearchParams } from "react-router-dom";

type Props = { children: React.ReactNode };

const NotAuthRoute = ({ children }: Props) => {
    const location = useLocation();
    const { isLoggedIn } = useAuth();
    const [searchParams] = useSearchParams();

    return !isLoggedIn() ? (
        <>{children}</>
    ) : (
        ((searchParams.get('ref') || "") != "") ? (
            <Navigate to={`/?ref=${searchParams.get('ref') || ""}`} state={{ from: location }} replace />
        ) : (
            <Navigate to={'/'} state={{ from: location }} replace />
        )
    );
};

export default NotAuthRoute;